import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { forwardRef, type ReactNode } from 'react';

type SideBarItemButtonProps = {
    icon: ReactNode;
    label: string;
    expanded: boolean;
    [key: string]: unknown;
};

export const SideBarItemButton = forwardRef<HTMLDivElement, SideBarItemButtonProps>(
    (props, ref) => {
        const { icon, label, expanded, ...rest } = props as SideBarItemButtonProps;
        return (
            <ListItemButton
                ref={ref}
                sx={{
                    minHeight: 48,
                    justifyContent: expanded ? 'initial' : 'center',
                    px: 2.5,
                }}
                {...rest}
            >
                <ListItemIcon
                    sx={{
                        minWidth: 0,
                        mr: expanded ? 2 : 'auto',
                        justifyContent: 'center',
                    }}
                >
                    {icon}
                </ListItemIcon>
                <ListItemText primary={label} sx={{ opacity: expanded ? 1 : 0 }} />
            </ListItemButton>
        );
    },
);
